import _ from 'lodash';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'variants' implicitly has an 'any' type.
const buildFilterOptions = (variants, attribute, uniqOnly = false, order = undefined) => {
  let options = _.map(variants, (variant) => ({
    id: variant.redbookCode,
    isBaseOption: variant.isBaseOption,
    value: variant[attribute.handle],
    sequenceNumber: variant.sequenceNumber,
  }));

  if (uniqOnly) {
    options = _.uniqBy(options, ({ value }) => value);
  }

  if (order) {
    options = _.orderBy(options, 'value', order);
  }

  return options;
};

export default buildFilterOptions;
